(function () {
  const toggle = document.querySelector("[data-menu-toggle]");
  const nav = document.querySelector("[data-nav]");
  if (toggle && nav) {
    toggle.addEventListener("click", function () {
      const open = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  const drawer = document.querySelector("[data-drawer]");
  const openers = document.querySelectorAll("[data-open-cart]");
  const closers = document.querySelectorAll("[data-close-cart]");

  function openCart() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.removeAttribute("hidden");
  }

  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("hidden", "");
  }

  openers.forEach(function (button) {
    button.addEventListener("click", function () {
      refreshCart().then(openCart);
    });
  });
  closers.forEach(function (button) {
    button.addEventListener("click", closeCart);
  });
  if (drawer) {
    drawer.addEventListener("click", function (event) {
      if (event.target === drawer) closeCart();
    });
  }

  function bindLines(scope) {
    scope.querySelectorAll("[data-line-key]").forEach(function (input) {
      input.addEventListener("change", function () {
        changeLine(input.dataset.lineKey, input.value);
      });
    });
  }

  function refreshCart() {
    return fetch(window.themeRoutes.cart + "?section_id=cart-ajax", { headers: { Accept: "text/html" } })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        const parsed = new DOMParser().parseFromString(html, "text/html");
        const nextItems = parsed.querySelector("[data-cart-items]");
        const list = document.querySelector("[data-drawer] [data-cart-items]");
        const total = document.querySelector("[data-cart-total]");
        const countSource = parsed.querySelector("[data-cart-count-source]");
        const totalSource = parsed.querySelector("[data-cart-total-source]");
        if (list && nextItems) list.innerHTML = nextItems.innerHTML;
        if (total && totalSource) total.textContent = totalSource.textContent;
        if (countSource) {
          document.querySelectorAll("[data-cart-count]").forEach(function (el) {
            el.textContent = countSource.textContent.trim();
          });
        }
        if (list) bindLines(list);
      });
  }

  function changeLine(key, quantity) {
    return fetch(window.themeRoutes.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: Number(quantity) })
    }).then(function () { return refreshCart(); });
  }

  document.querySelectorAll("[data-thumb]").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      const main = document.querySelector("[data-main-image]");
      if (!main) return;
      main.src = thumb.dataset.full;
      main.removeAttribute("srcset");
      document.querySelectorAll("[data-thumb]").forEach(function (el) {
        el.classList.remove("is-selected");
      });
      thumb.classList.add("is-selected");
    });
  });

  const form = document.querySelector("[data-product-form]");
  if (form) {
    const idInput = form.querySelector("[name='id']");
    const priceEl = document.querySelector("[data-product-price]");
    const button = form.querySelector("[data-add]");
    document.querySelectorAll("[data-swatch]").forEach(function (swatch) {
      swatch.addEventListener("click", function (event) {
        event.preventDefault();
        document.querySelectorAll("[data-swatch]").forEach(function (el) {
          el.classList.remove("is-selected");
          el.removeAttribute("aria-current");
        });
        swatch.classList.add("is-selected");
        swatch.setAttribute("aria-current", "true");
        idInput.value = swatch.dataset.variantId;
        if (priceEl) priceEl.textContent = swatch.dataset.price;
        const colorLabel = document.querySelector("[data-color-label]");
        if (colorLabel && swatch.dataset.label) colorLabel.textContent = swatch.dataset.label;
        const main = document.querySelector("[data-main-image]");
        if (main && swatch.dataset.image) {
          main.src = swatch.dataset.image;
          main.removeAttribute("srcset");
          main.alt = swatch.dataset.label || main.alt;
        }
        const available = swatch.dataset.available === "true";
        button.disabled = !available;
        button.textContent = available ? button.dataset.label : button.dataset.soldout;
        const url = new URL(window.location.href);
        url.searchParams.set("variant", swatch.dataset.variantId);
        history.replaceState({}, "", url);
      });
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      const quantityInput = form.querySelector("[name='quantity']");
      button.disabled = true;
      fetch(window.themeRoutes.cartAdd + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          id: Number(idInput.value),
          quantity: Number(quantityInput ? quantityInput.value : 1)
        })
      }).then(function (response) {
        if (!response.ok) throw new Error("cart");
        return refreshCart();
      }).then(function () {
        openCart();
      }).catch(function () {
        form.submit();
      }).finally(function () {
        button.disabled = false;
      });
    });
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeCart();
  });
})();
